import * as React from "react"
import Map, {GoogleApiWrapper} from "google-maps-react"
import {Directions} from "./Directions"
import {googlePlaceId} from "../model/journey"
import {Place} from "../model/places/PlaceTypes"
import {Locale} from "../model/BookingTypes"
import {Loader} from "semantic-ui-react"
import {BookingFormJourneyState} from "../state"

export interface MapContainerStyle {
  height: string
  width: string
}

const containerStyle: MapContainerStyle = {
  height: "70vh",
  width: "100%",
}

const mapStyle = {
  height: "100%",
}

function reorderedWaypoints(order: Array<number>) {
  return !order.every((i, index) => i === index)
}

// Waypoints are independent of google directions status but *if* the directions
// are OK we will reorder our waypoints if necessary.
function newWaypoints(
  status: string,
  directionsRoute: any,
  waypoints: Array<Place>,
): Array<Place> | null {
  if (status !== "OK") {
    return null
  }

  const order = directionsRoute.waypoint_order

  return reorderedWaypoints(order) ? order.map((index: number) => waypoints[index]) : null
}

interface OwnProps {
  journey: BookingFormJourneyState
  locale: Locale
  onOptimizedWaypoints: ((waypoints: Array<Place> | null) => void) | null
  zoom?: number
  containerStyle?: MapContainerStyle
}

interface MapProps {
  loaded?: boolean
  google?: any
}

type Props = OwnProps & MapProps

class DirectionsMap extends React.Component<Props> {
  // status OK indicates the response contains a valid DirectionsResult.
  handleDirections = (status: string, directionsRoute: any) => {
    const {onOptimizedWaypoints} = this.props

    if (onOptimizedWaypoints) {
      const {journey} = this.props

      const waypoints = newWaypoints(status, directionsRoute, journey.waypoints)

      onOptimizedWaypoints(waypoints)
    }
  }

  render() {
    if (!this.props.loaded) {
      return <Loader active />
    }

    const {
      journey: {origin, destination, waypoints},
      onOptimizedWaypoints,
      locale,
      zoom,
    } = this.props
    const effectiveZoom = zoom || 12
    const effectiveContainerStyle = this.props.containerStyle || containerStyle

    const location = {
      lat: locale.mapLatitude,
      lng: locale.mapLongitude,
    }

    return (
      // This is my hack to ensure the map column/div has the same height as the map, and so can be
      // seen when the columns stack on mobile.
      <div style={{height: effectiveContainerStyle.height}}>
        <Map
          style={mapStyle}
          containerStyle={effectiveContainerStyle}
          google={this.props.google}
          zoom={effectiveZoom}
          initialCenter={location}
          clickableIcons={false}
        >
          <Directions
            origin={googlePlaceId(origin)}
            destination={googlePlaceId(destination)}
            waypoints={waypoints.map((it) => googlePlaceId(it))}
            optimizeWaypoints={onOptimizedWaypoints !== null}
            onDirections={this.handleDirections}
            defaultLocation={location}
            countryCode={locale.countryCode}
          />
        </Map>
      </div>
    )
  }
}

/*
 The apiKey below can be created/replaced/restricted in the google dev console.
 This key is for the frontend and there is also a backend key use to service place requests
 made through the graphql service.  The backend key should be restricted to the IP address of the
 backend server and the frontend key should be restricted to a "Referrer" being the sites (eg.)
 cusoon2.gtod.net/* (dev) or cusoon.com.au/* (production).
 */
const withMap: React.ComponentClass<OwnProps> = GoogleApiWrapper({
  version: "weekly",
  apiKey: "AIzaSyAYJwbj6l_y3xqGu7IZ1uPHBd-1HITjmAI",
  libraries: ["places"],
})(DirectionsMap)

export {withMap as DirectionsMap}



// WEBPACK FOOTER //
// ./src/components/DirectionsMap.tsx